import { render } from "./FooterMobileComponent.vue?vue&type=template&id=aae96b6c"
import script from "./FooterMobileComponent.vue?vue&type=script&lang=js"
export * from "./FooterMobileComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__